module.exports = __webpack_public_path__ + "media/images/background/background-login-53f605e1f292aa0fab7c4812ebd4b909.svg";